// Symphony design system — the shared UI primitives. Import from here:
//   import { Button, Card, Typography } from '../ui';
export { Typography } from './Typography';
export type { TypographyProps, TypographyVariant, TypographyColor } from './Typography';

export { Button } from './Button';
export type { ButtonProps, ButtonVariant, ButtonSize, ButtonColor } from './Button';

export { IconButton } from './IconButton';
export type { IconButtonProps, IconButtonSize, IconButtonVariant, IconButtonColor } from './IconButton';

export { BackButton } from './BackButton';

export { TextButton } from './TextButton';
export type { TextButtonProps, TextButtonSize, TextButtonColor } from './TextButton';

export { Input } from './Input';
export type { InputProps, InputKind, InputSize, InputSkin, InputStatus } from './Input';

export { Avatar, AVATAR_DS_SIZES } from './Avatar';
export type { AvatarProps, AvatarColor } from './Avatar';

export { Card } from './Card';
export type { CardProps, CardVariant, CardSize } from './Card';

export { Tabs } from './Tabs';
export type { TabsProps, TabsSize, TabItem } from './Tabs';

export { Badge, StatusBadge, TaskRowBadge } from './Badge';
export type { BadgeProps, BadgeVariant, BadgeSize } from './Badge';

export { IconCountBadge, IconCountBadges } from './IconCountBadge';

export { Toast } from './Toast';
export type { ToastProps, ToastSeverity } from './Toast';

export { Collapsible } from './Collapsible';
export type { CollapsibleProps } from './Collapsible';

export { ProgressBar } from './ProgressBar';
export type { ProgressBarProps, ProgressBarType, ProgressLevel, PasswordLevel } from './ProgressBar';

export { ProgressRing } from './ProgressRing';
export type { ProgressRingProps } from './ProgressRing';

export { PageLoader } from './PageLoader';

export { Switch } from './Switch';
export type { SwitchProps, SwitchLabelPlacement } from './Switch';

export { OverflowMenu } from './OverflowMenu';
export type { OverflowMenuAction } from './OverflowMenu';

export { ScrollArea } from './ScrollArea';
export type { ScrollAreaProps, ScrollAreaAxis, ScrollAreaBar } from './ScrollArea';

export { RadioGroup, CheckboxGroup, SelectionIndicator } from './RadioGroup';
export type {
  RadioGroupProps,
  CheckboxGroupProps,
  RadioOption,
  RadioGroupVariant,
  RadioGroupOrientation,
  IndicatorPlacement,
  SelectionShape,
} from './RadioGroup';

export { SegmentedToggle } from './SegmentedToggle';
export type {
  SegmentedToggleProps,
  SegmentedToggleOption,
  SegmentedToggleSize,
  SegmentedToggleType,
  SegmentedToggleTextPlacement,
  SegmentedToggleWidth,
} from './SegmentedToggle';

export { SocialLogo, socialBadgeColor, socialLogoColor } from './SocialLogo';
export type { SocialLogoKey } from './SocialLogo';

export { TruncatedText, useTruncatedTitle } from './TruncatedText';
